import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPccmPreflightCheck, getPccmGvcnCheck } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

const DAYS = ["Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"];

// "Kiểm tra trước khi xếp": quét PCCM + lịch bận + lịch phân phối nghề-văn
// hoá của tuần, phát hiện GV có nguy cơ kẹt lịch CẤU TRÚC (kiểu "cô Vũ Thị
// Thủy" — lịch bận quá hẹp, nhiều lớp cùng tranh 1 buổi rảnh hiếm hoi) —
// TRƯỚC KHI chạy CP-SAT, để chủ động cân nhắc đổi PCCM/pool thay vì chỉ phát
// hiện SAU khi xếp xong rồi lại sửa. Chỉ là ước lượng nhanh, không thay thế
// bộ giải thật (không tính hết ràng buộc liền khối/tối đa tiết ngày).
const HappySchoolPreflightCheck = ({ weekId }) => {
  const schoolId = getActiveSchoolId();
  const [teachers, setTeachers] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [gvcnViolations, setGvcnViolations] = useState(null);
  const [gvcnLoading, setGvcnLoading] = useState(false);

  useEffect(() => {
    if (!schoolId || !weekId) return;
    setLoading(true);
    setError("");
    getPccmPreflightCheck(schoolId, weekId)
      .then((r) => setTeachers(r.teachers || []))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [schoolId, weekId]);

  useEffect(() => {
    if (!schoolId) return;
    setGvcnLoading(true);
    getPccmGvcnCheck(schoolId)
      .then((r) => setGvcnViolations(r || []))
      .catch(() => setGvcnViolations([]))
      .finally(() => setGvcnLoading(false));
  }, [schoolId]);


  if (!schoolId) {
    return <div style={{ padding: 16 }}>Chưa chọn trường. Vào <Link to="/happyschool/schools">Trường của tôi</Link>.</div>;
  }
  if (!weekId) return <p style={{ color: "#6b7280" }}>Chưa chọn tuần TKB.</p>;
  if (loading) return <p>Đang kiểm tra...</p>;
  if (error && teachers === null) return <p style={{ color: "#dc2626" }}>{error}</p>;

  return (
    <div>
      {error && <p style={{ color: "#dc2626", fontSize: 13 }}>{error}</p>}

      <div style={{ marginBottom: 20, paddingBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
        <h4 style={{ margin: "0 0 6px" }}>GVCN chưa dạy đúng lớp mình chủ nhiệm</h4>
        <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
          Quy tắc: GV chủ nhiệm nếu có dạy bộ môn nào thì phải xếp dạy chính bộ môn đó cho lớp mình chủ nhiệm. Không tự
          sửa PCCM — chỉ báo để bạn cân nhắc đổi qua "Điều chuyển PCCM".
        </p>
        {gvcnLoading ? (
          <p>Đang kiểm tra...</p>
        ) : !gvcnViolations || gvcnViolations.length === 0 ? (
          <p style={{ color: "#166534", fontWeight: 600 }}>✓ Không phát hiện vi phạm nào.</p>
        ) : (
          <table style={{ borderCollapse: "collapse", fontSize: 12, width: "100%" }}>
            <thead>
              <tr>
                <th style={th}>Lớp</th>
                <th style={{ ...th, textAlign: "left" }}>Môn</th>
                <th style={{ ...th, textAlign: "left" }}>GVCN (dạy được môn này)</th>
                <th style={{ ...th, textAlign: "left" }}>Hiện đang do</th>
              </tr>
            </thead>
            <tbody>
              {gvcnViolations.map((v, i) => (
                <tr key={i} style={{ background: "#fee2e2" }}>
                  <td style={{ ...td, fontWeight: 600 }}>{v.className}</td>
                  <td style={{ ...td, textAlign: "left" }}>{v.subjectName}</td>
                  <td style={{ ...td, textAlign: "left" }}>{v.gvcnName}</td>
                  <td style={{ ...td, textAlign: "left" }}>{v.currentTeacherName}{v.inPool ? " (GVCN đang ở pool dự phòng)" : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Quét PCCM + lịch bận + lịch phân phối nghề-văn hoá của tuần này, phát hiện GV có nguy cơ kẹt lịch
        <b> cấu trúc</b> (lớp cần nhiều tiết nhưng GV chỉ rảnh đúng vài buổi hiếm hoi) — để cân nhắc đổi PCCM
         <b>TRƯỚC KHI</b> bấm "Chạy xếp TKB", thay vì chỉ phát hiện sau khi xếp xong. Đây chỉ là ước lượng
        nhanh (chưa tính hết mọi ràng buộc như bộ giải thật), dùng để tham khảo.
      </p>
      {teachers === null || teachers.length === 0 ? (
        <p style={{ color: "#166534", fontWeight: 600 }}>✓ Không phát hiện GV nào có nguy cơ kẹt lịch cấu trúc rõ rệt.</p>
      ) : (
        <>
          <p style={{ fontWeight: 600, color: "#b91c1c", marginBottom: 12 }}>⚠ {teachers.length} GV có nguy cơ kẹt lịch:</p>
          {teachers.map((t) => (
            <div key={t.teacherId} style={{ border: "1px solid #fca5a5", background: "#fef2f2", borderRadius: 8, padding: 14, marginBottom: 12 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 }}>
                <strong style={{ fontSize: 15 }}>{t.name}</strong>
                <span style={{ fontSize: 12, color: "#6b7280" }}>
                  Tổng cần: <b>{t.demand}</b> tiết/tuần — sức chứa ước tính: <b>{t.totalCapacity}</b> tiết
                  {t.aggregateShort && <span style={{ color: "#b91c1c", fontWeight: 700 }}> (THIẾU {t.demand - t.totalCapacity})</span>}
                </span>
              </div>
              <table style={{ borderCollapse: "collapse", fontSize: 12, width: "100%", marginTop: 8 }}>
                <thead>
                  <tr>
                    <th style={th}>Lớp</th>
                    <th style={{ ...th, textAlign: "left" }}>Môn</th>
                    <th style={th}>Cần</th>
                    <th style={th}>Tiết rảnh trùng</th>
                    <th style={{ ...th, textAlign: "left" }}>Gợi ý đổi PCCM</th>
                  </tr>
                </thead>
                <tbody>
                  {t.classes.map((c, i) => {
                    const bad = c.freePeriodsCount === 0 || c.short;
                    return (
                      <tr key={i} style={bad ? { background: "#fee2e2" } : {}}>
                        <td style={{ ...td, fontWeight: 600 }}>{c.className}</td>
                        <td style={{ ...td, textAlign: "left" }}>{c.subjectName}</td>
                        <td style={td}>{c.need}</td>
                        <td style={{ ...td, fontWeight: bad ? 700 : 400, color: bad ? "#b91c1c" : "#374151" }}>
                          {c.freePeriodsCount === 0 ? "KHÔNG tiết nào" : `${c.freePeriodsCount} tiết${c.short ? " (không đủ riêng lớp này)" : ""}`}
                        </td>
                        <td style={{ ...td, textAlign: "left" }}>
                          {!bad ? (
                            "—"
                          ) : !c.suggestion ? (
                            <span style={{ color: "#9ca3af" }}>Không tìm được GV nào khác phù hợp</span>
                          ) : (
                            <span>{c.suggestion.name} (rảnh {c.suggestion.coverage} tiết) — muốn dùng thì đổi PCCM (GV chính)</span>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {t.collisions && t.collisions.length > 0 && (
                <div style={{ marginTop: 8, fontSize: 12, color: "#b91c1c" }}>
                  {t.collisions.map((col, i) => (
                    <div key={i}>
                      ⚠ <b>{DAYS[col.day]}-{col.session === 0 ? "sáng" : "chiều"}</b>: {col.classNames.join(", ")} cùng chỉ rảnh đúng buổi này, tổng cần {col.totalNeed} tiết {">"} 5 tiết của 1 buổi.
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </>
      )}
    </div>
  );
};

const th = { border: "1px solid #e5e7eb", padding: "5px 8px", background: "#fff", whiteSpace: "nowrap", textAlign: "center" };
const td = { border: "1px solid #e5e7eb", padding: "5px 8px", textAlign: "center", background: "#fff" };

export default HappySchoolPreflightCheck;
